import { ListWrapper } from '@/components/composite/SocialProfiles/Components/ListWrapper';

export function GroupsLoader() {
    return (
        <ListWrapper data-testid="menu-groups-loader">
            {Array.from({ length: 6 }).map((_, index) => (
                <div
                    data-testid="group-menu-loading-item"
                    className="h-10.5 w-10.5 animate-pulse rounded-md border-2 border-white bg-white/40 dark:border-icoDarkMode-deepBlack"
                    key={index}
                />
            ))}
        </ListWrapper>
    );
}
